import {
  useLazyGetAccessStudyLogsQuery,
  useLazyGetActionLogDataQuery,
  useGetCommonStudyLogsMutation,
  useLazyGetProtocolDeviationLogDataQuery,
  useLazyGetSiteStudyPersonnelQuery,
  useLazyGetStudyLogQuery
} from 'src/services/StudyLogs';

export const useStudyLog = () => {
  const [
    getProtocolDevationData,
    {
      isLoading: protoclDeviationDataLoading,
      isSuccess: protoclDeviationDataSuccess,
      data: protoclDeviationData,
      isError: protoclDeviationDataIsError,
      error: protoclDeviationDataError
    }
  ] = useLazyGetProtocolDeviationLogDataQuery();

  const [
    getActionDataFn,
    {
      isLoading: actionDataLoading,
      isSuccess: actionDataSuccess,
      data: actionData,
      isError: actionDataIsError,
      error: actionDataError
    }
  ] = useLazyGetActionLogDataQuery();

  const [
    getStudyPersonnelData,
    {
      isLoading: personelDataLoading,
      isSuccess: personelDataSuccess,
      data: personelData,
      isError: personelDataIsError,
      error: personelDataError
    }
  ] = useLazyGetSiteStudyPersonnelQuery();

  const [
    getStudyLogsData,
    {
      data: studyLogsData,
      error: studyLogsError,
      isError: studyLogsIsError,
      isLoading: studyLogsIsLoading,
      isSuccess: studyLogsIsSuccess
    }
  ] = useLazyGetStudyLogQuery();
  const [
    getAccessStudyLogs,
    {
      data: ctmsStudyLogsData,
      error: ctmsStudyLogsError,
      isError: ctmsStudyLogsIsError,
      isLoading: ctmsStudyLogsIsLoading,
      isSuccess: ctmsStudyLogsIsSuccess
    }
  ] = useLazyGetAccessStudyLogsQuery();

  const [
    getCommonStudyLogs,
    {
      data: commonStudyLogsData,
      error: commonStudyLogsError,
      isError: commonStudyLogsIsError,
      isLoading: commonStudyLogsIsLoading,
      isSuccess: commonStudyLogsIsSuccess
    }
  ] = useGetCommonStudyLogsMutation();

  return {
    getProtocolDevationData,
    getActionDataFn,
    protoclDeviationDataLoading,
    protoclDeviationDataSuccess,
    protoclDeviationData,
    protoclDeviationDataIsError,
    protoclDeviationDataError,
    actionDataLoading,
    actionDataSuccess,
    actionData,
    actionDataIsError,
    actionDataError,
    getStudyPersonnelData,
    personelDataLoading,
    personelDataSuccess,
    personelData,
    personelDataIsError,
    personelDataError,
    getStudyLogsData,
    studyLogsData,
    studyLogsError,
    studyLogsIsError,
    studyLogsIsLoading,
    studyLogsIsSuccess,
    getAccessStudyLogs,
    ctmsStudyLogsData,
    ctmsStudyLogsError,
    ctmsStudyLogsIsError,
    ctmsStudyLogsIsLoading,
    ctmsStudyLogsIsSuccess,
    getCommonStudyLogs,
    commonStudyLogsData,
    commonStudyLogsError,
    commonStudyLogsIsError,
    commonStudyLogsIsLoading,
    commonStudyLogsIsSuccess
  };
};
